import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import AsyncCreatableSelect from "react-select/lib/AsyncCreatable";
import Async from "react-select/lib/Async";

import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import { emphasize } from "@material-ui/core/styles/colorManipulator";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import { doLoad, select, doPost } from '../Redux/Actions'
import store from '../Redux';
import { connect } from 'react-redux'

const styles = theme => ({
    root: {
        flexGrow: 1,
        zIndex: 999,
        overflow: "inherit"
    },
    input: {
        display: "flex",
        padding: 0
    },
    valueContainer: {
        display: "flex",
        flex: 1,
        alignItems: "center"
    },
    noOptionsMessage: {
        fontSize: 16,
        padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
    },
    singleValue: {
        fontSize: 16
    },
    placeholder: {
        position: "absolute",
        left: 2,
        fontSize: 16
    },
    label: {
        fontSize: "13px"
    }
});

const selectStyles = {
  //control: provided => ({ ...provided, minWidth: 240, margin: 8 }),
  menu: (current) => ({
      ...current,
      borderRadius: 0,
      width: 'initial',
      zIndex: 999,
      //boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)'
  }),
  menuList: (current) => ({
      ...current,
      padding: 0,
  }),
};

function NoOptionsMessage(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.noOptionsMessage}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function inputComponent({ inputRef, ...props }) {
    return <div ref={inputRef} {...props} />;
}

function Control(props) {
    return (
        <TextField
            fullWidth
            InputProps={{
                inputComponent,
                inputProps: {
                    className: props.selectProps.classes.input,
                    ref: props.innerRef,
                    children: props.children,
                    ...props.innerProps
                }
            }}
        />
    );
}

function Option(props) {
    return (
        <MenuItem
            buttonRef={props.innerRef}
            selected={props.isFocused}
            component="div"
            style={{
                fontWeight: props.isSelected ? 500 : 400,
                borderBottom: 'solid 1px #ddd'
            }}
            {...props.innerProps}
        >
            {props.children}
        </MenuItem>
    );
}

function Placeholder(props) {
    return (
        <Typography
            color="textSecondary"
            className={props.selectProps.classes.placeholder}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function SingleValue(props) {
    return (
        <Typography
            className={props.selectProps.classes.singleValue}
            {...props.innerProps}
        >
            {props.children}
        </Typography>
    );
}

function ValueContainer(props) {
    return (
        <div className={props.selectProps.classes.valueContainer}>
            {props.children}
        </div>
    );
}

const components = {
    Option,
    Control,
    NoOptionsMessage,
    Placeholder,
    SingleValue,
    ValueContainer
};

// menuIsOpen

class SelectDropdown extends React.Component {

    state = { 
        isOpen: false,
        value: undefined,
        items: [],
        isLoading: true
    };

    onSelectChange = value => {
        this.toggleOpen();
        this.props.handleChange(value)
    }

    loadOptions = (inputValue, callback) => {
        var { redux, uri } = this.props
        this.props.doLoad(redux, uri, {s: inputValue})
        this.callback = callback
    }

    componentDidMount() {
        this.unsubscribe = store.subscribe(() => {
            var generic = select(store.getState(), this.props.redux)
            if(_.has(generic, "data")) {
                this.state.items = generic.data.map(item => ({
                    value: item.id,
                    label: item.name,
                    ...item
                }))
                if(this.callback !== undefined) {
                    this.callback(this.state.items)
                }
            }
            if(this.state.isLoading) {
                this.setState({
                    isLoading: generic.isLoading
                })
            }
        })
    }

    handleCreate = (inputValue) => {
        this.setState({
            isLoading: true
        })
        var { redux, uri } = this.props
        this.props.doPost(redux, uri, {name: inputValue})
    }

    componentWillUnmount() {
        if(this.unsubscribe !== undefined) {
            this.unsubscribe()
        }
    }

    handleClickAway = () => {

    }

    render() {
        var { isLoading, items } = this.state
        const { classes, suggestions, name, placeholder, isMulti, canCreate } = this.props;
        return (
            <ClickAwayListener onClickAway={this.handleClickAway}>
                <div className={classes.root}>
                    <InputLabel className={classes.label} htmlFor={name}>{name}</InputLabel>
                    {canCreate === undefined && <AsyncCreatableSelect

                        defaultOptions
                        isMulti={isMulti}

                        label={name}
                        key={name+"select"}
                        classes={classes}
                        
                        onInputChange={this.props.onInputChange}
                        options={items}
                        loadOptions={this.loadOptions}

                        isDisabled={isLoading}
                        isLoading={isLoading}

                        components={components}

                        value={this.props.value}
                        onChange={this.props.handleChange}
                        onInputChange={this.props.onInputChange}
                        placeholder={placeholder}

                        noOptionsMessage={() => "Keine weiteren Einträge..."}
                        formatCreateLabel={(inputValue: string) => `"${inputValue}" erstellen?`}

                        onCreateOption={this.handleCreate}
                        styles={selectStyles}

                    />}
                    {canCreate === false && <Async

                        defaultOptions
                        isMulti={isMulti}

                        label={name}
                        key={name+"select"}
                        classes={classes}
                        
                        onInputChange={this.props.onInputChange}
                        options={items}
                        loadOptions={this.loadOptions}

                        isDisabled={isLoading}
                        isLoading={isLoading}

                        components={components}

                        value={this.props.value}
                        onChange={this.props.handleChange}
                        onInputChange={this.props.onInputChange}
                        placeholder={placeholder}

                        noOptionsMessage={() => "Keine weiteren Einträge..."}

                        onCreateOption={this.handleCreate}
                        styles={selectStyles}

                    />}
                </div>
            </ClickAwayListener>
        );
    }
}

SelectDropdown.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    produkte: state.produkte,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doLoad: (redux, uri, filter) => dispatch(doLoad(redux, "api/generic/"+uri+"/list", filter)),
    doPost: (redux, uri, postData) => dispatch(doPost(redux, "api/generic/"+uri+"", postData)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(SelectDropdown));



// WEBPACK FOOTER //
// ./src/Components/SelectDropdown.js